import { StyledForm } from '@framework/form/form/StyledForm.tsx';
import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { type ButtonProps } from 'antd';
import { type IReference } from '../../../references/IReference.ts';
import { type IAsyncService } from '../context/IAsyncService.ts';
import { AsyncServiceInputsInput } from './AsyncServiceInputsInput.tsx';

export interface IAsyncExpressionOptionsInputProps {
  service: IAsyncService | undefined;
  references: IReference[];
  name: string;
  size?: ButtonProps['size'];
}

export function AsyncExpressionOptionsInput(
  props: IAsyncExpressionOptionsInputProps,
) {
  const { service, references, name, size } = props;
  if (!service) return null;

  return (
    <StyledForm>
      <FormItem name={`${name}.inputs`} label="Input">
        <AsyncServiceInputsInput
          name={`${name}.inputs`}
          service={service}
          references={references}
          size={size}
        />
      </FormItem>
      <FormItem
        name={`${name}.output`}
        label="Output"
        layout={{ removeHelpMargin: true }}
      >
        <SelectInput
          size={size}
          name={`${name}.output`}
          options={service.outputs.map(output => ({
            value: output.name,
            label: output.name,
          }))}
        />
      </FormItem>
    </StyledForm>
  );
}
